import React from 'react'
import styled from '@emotion/styled'
import { GatsbyImage } from 'gatsby-plugin-image'
import { VscMail, VscHome } from 'react-icons/vsc'
import { FaGithubAlt } from 'react-icons/fa'

import externalURL from '~/constants/externalUrl'

import { useProfileImage } from '~/hooks/profile'

import { Br } from '~/styles/text'
import { ProfileLabel } from '~/styles/styled'

const Profile: React.VFC = () => {
  const { profileImage } = useProfileImage()

  return (
    <Container>
      <Image image={profileImage} alt="profile" />

      <TextWrapper>
        <ProfileLabel>@1000peach</ProfileLabel>
        <p>
          안녕하세요. 👋
          <br />
          주니어 프론트엔드 개발자 <em>천승아</em>입니다. <Br show="mobile" />
          피드백은 언제나 환영합니다.
        </p>

        <ul>
          <li>
            <a href={externalURL.github} target="_blank">
              <FaGithubAlt />
            </a>
          </li>
          <li>
            <a href={`mailto:${externalURL.gmail}`}>
              <VscMail />
            </a>
          </li>
          <li>
            <a href={externalURL.notion} target="_blank">
              <VscHome />
            </a>
          </li>
        </ul>
      </TextWrapper>
    </Container>
  )
}

const Container = styled.section`
  padding: 45px 0;
  display: flex;

  @media ${({ theme: { device } }) => device.mobile} {
    padding: 30px 0;
    align-items: center;
    column-gap: 17px;
  }
`

const Image = styled(GatsbyImage)`
  width: 130px;
  height: 130px;
  border-radius: 50%;

  img {
    border-radius: 50%;
  }

  @media ${({ theme: { device } }) => device.mobile} {
    width: 110px;
    height: 110px;
    margin-bottom: 10px;
  }
`

const TextWrapper = styled.section`
  margin-left: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 10px;

  // description
  > p {
    ${({ theme: { typography } }) => typography.body3}
    font-size: 15px;
    color: ${({ theme: { colors } }) => colors.deepText};
    line-height: 23px;
    text-align: left;

    @media ${({ theme: { device } }) => device.mobile} {
      line-height: 20px;
    }

    em {
      font-style: normal;
      font-weight: 500;
      color: ${({ theme: { palette } }) => palette.purple};
    }
  }

  // tags
  > ul {
    display: flex;
    column-gap: 10px;

    svg {
      fill: ${({ theme: { colors } }) => colors.darkText};
    }
  }

  @media ${({ theme: { device } }) => device.mobile} {
    margin-left: 0;
    align-items: flex-start;
    text-align: center;
    row-gap: 7px;
  }
`

export default Profile
